import React from 'react';
import { Box } from '@mui/material';
import CampaignCard from './CampaignCard';

interface CampaignListProps {
  campaigns: any[];
  hideBuy?: boolean;
}

const CampaignList: React.FC<CampaignListProps> = ({ campaigns, hideBuy }) => {
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', mt: 4 }}>
      {campaigns.map((campaign: any) => (
        <CampaignCard
          key={campaign.nSaleId || campaign.purchaseId}
          saleId={campaign.nSaleId}
          title={campaign.vTitle || 'Untitled'}
          image={campaign.vSmlImg || 'default-image.jpg'}
          description={campaign.vDescription || 'No description available'}
          price={typeof campaign.nValue === 'number' ? campaign.nValue : 0}
          hideBuy={hideBuy}
          purchaseId={campaign.purchaseId}
          cardNum={campaign.cardNum}
        />
      ))}
    </Box>
  );
};

export default CampaignList;
